// pages/test-email.js

import { useState } from "react";

export default function TestEmail() {
  const [status, setStatus] = useState({
    loading: false,
    error: null,
    success: false,
    details: null,
  });

  const handleTestEmail = async () => {
    setStatus({ loading: true, error: null, success: false, details: null });

    try {
      const response = await fetch("/api/test-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to send test email");
      }

      setStatus({
        loading: false,
        error: null,
        success: true,
        details: data,
      });
    } catch (err) {
      console.error("Test email error:", err);
      setStatus({
        loading: false,
        error: err.message,
        success: false,
        details: err,
      });
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-semibold mb-4">
          Email Configuration Test
        </h1>

        <div className="mb-4">
          <p className="text-gray-600">
            This will send a test email to: herezainali@gmail.com
          </p>
        </div>

        <button
          onClick={handleTestEmail}
          disabled={status.loading}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
        >
          {status.loading ? "Sending..." : "Send Test Email"}
        </button>

        {status.error && (
          <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
            <h3 className="font-semibold">Error:</h3>
            <p>{status.error}</p>
            {status.details && (
              <pre className="mt-2 text-sm overflow-auto">
                {JSON.stringify(status.details, null, 2)}
              </pre>
            )}
          </div>
        )}

        {status.success && (
          <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
            <p className="font-semibold">Test email sent successfully!</p>
            <p className="mt-2">Please check herezainali@gmail.com</p>
          </div>
        )}
      </div>
    </div>
  );
}
